"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuContext = exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _helpers = require("../utils/helpers");

var _MenuStyled = require("./Menu-styled");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MenuContext = (0, _react.createContext)({
  extraSmall: undefined,
  small: undefined,
  large: undefined,
  extraLarge: undefined
});
exports.MenuContext = MenuContext;
MenuContext.displayName = 'MenuContext';
var Menu = (0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      extraSmall = _ref.extraSmall,
      small = _ref.small,
      large = _ref.large,
      extraLarge = _ref.extraLarge,
      other = _objectWithoutProperties(_ref, ["children", "extraSmall", "small", "large", "extraLarge"]);

  var menuContext = (0, _helpers.useContextState)({
    extraSmall: extraSmall,
    small: small,
    large: large,
    extraLarge: extraLarge
  });
  return _react.default.createElement(MenuContext.Provider, {
    value: menuContext
  }, _react.default.createElement(_MenuStyled.StyledMenu, _extends({
    ref: ref,
    extraSmall: extraSmall,
    small: small,
    large: large,
    extraLarge: extraLarge
  }, other), children));
});
exports.default = Menu;
Menu.propTypes = {
  /** Content node for the Menu. */
  children: _propTypes.default.node,

  /** Style prop used to render an extra small Menu. */
  extraSmall: _propTypes.default.bool,

  /** Style prop used to render a small Menu. */
  small: _propTypes.default.bool,

  /** Style prop used to render a large Menu. */
  large: _propTypes.default.bool,

  /** Style prop used to render an extra large Menu. */
  extraLarge: _propTypes.default.bool
};
Menu.defaultProps = {};
Menu.displayName = 'Menu';